export const imageNodeName = 'image';

export const ImageAttr = {
    Src: 'src',
    Alt: 'alt',
    Title: 'title',
    Loading: 'loading',
} as const;
